import Device from '@/helpers/Device';
import PowerStateWrapper from "@/helpers/Device/PowerStateWrapper";
import StorageHandler, {
  STORE_KEY,
  STORE_VALUE,
} from '@/helpers/StorageHandler';
import store from '@/store';

console.log("TIZEN keyHandler b2bapis (window):", window.hasB2bapis);
console.log("TIZEN keyHandler webapis (window):", window.hasWebapis);

export default class KeyHandlingTizen {
  static get getKeys() {
    return [
      'Menu',             //18
      'ChannelUp',        //427
      'ChannelDown',      //428
      'Exit',             //10182
      'XF86Exit',         //10182
      'XF86SysMenu',      //10133
      'ChannelList',      //10073 (Info)
      'XF86Ambient',      //10232
      'PreviousChannel',  //10190
      'Guide',            //458
      'MediaPlay',        //415
      'MediaPlayPause',   //10252 (XF86Home / SmartHub)
      'MediaPause',       //19
      'MediaStop',        //413
      'MediaFastForward', //417
      'MediaRewind',      //412
      'Info',             //457
      '0',                //48
      '1',                //49
      '2',                //50
      '3',                //51
      '4',                //52
      '5',                //53
      '6',                //54
      '7',                //55
      '8',                //56
      '9',                //57
      'Minus',            //189
      'ColorF0Red',       //403
      'ColorF1Green',     //404
      'ColorF2Yellow',    //405
      'ColorF3Blue',      //406
      'Tools',            //10135 (Menu)
      'Source',           //10072
      'Search',           //10225
      'Back',             //10009
      'Enter',            //13
      'Home',             //10071
      'Voice ',           //10253 (Settings)
      'Netflix',          //10074
      'PrimeVideo',       //10256
      'DisneyPlus',       //10257
      'SamsungTVPlus',    //10258
      'GamingHub',        //10259
      'ArtMode',          //10260
      'Apps',             //10077
      'HotelInfo',        //10300
      'HotelMenu',        //10301
      'Interactive',      //10302
      'MyRoom',           //10303
      'TVPlus',           //10303
      'MultiView',        //10303
      'WebBrowser',       //10303
      'Ambient',          //10303
      //'Power',          //409
    ];
  }

  static powerWrapper = null;

  static get getSpecialKeys() {
    return ['SmartHub', 'TVPlus', 'MultiView', 'WebBrowser', 'Power', 'Sleep', 'XF86Ambient', 'Ambient', 'Apps', 'SamsungTVPlus'];
  }

  static registerKeys() {
    for (let i = 0; i < this.getSpecialKeys.length; i++) {
      try {
        webapis.appcommon.registerKey([this.getSpecialKeys[i]]);
        /*
        store.dispatch('notification/new', {
          title: 'Assign Key',
          message: this.getSpecialKeys[i],
        });
        */
      } catch (error) {
        console.log('failed to register - specialkeys: ' + this.getSpecialKeys[i] + ': ' + error);
      }
    }
    // try {
    //   const value = webapis.appcommon.registerKey([this.getSpecialKeys]);
    //   console.log(' result = ' + value);
    // } catch (error) {
    //   console.log(' error code = ' + error.code);
    // }
    // var keyCodes = {};
    // var supportedKeys = tizen.inputdevice.getSupportedKeys();

    // console.log('Supported keys list');
    // for (var i = 0; i < supportedKeys.length; ++i) {
    //   keyCodes[supportedKeys[i].name] = supportedKeys[i].code;
    //   console.log(
    //     i + ' : ' + supportedKeys[i].name + ' - ' + supportedKeys[i].code
    //   );
    // }
    for (let i = 0; i < this.getKeys.length; i++) {
      try {
        tizen.tvinputdevice.registerKey(this.getKeys[i]);
      } catch (error) {
        console.log('failed to register: ' + this.getKeys[i] + ': ' + error);
      }
    }
    const keys = ['VolumeDown', 'VolumeUp', 'VolumeMute'];
    for (let i = 0; i < keys.length; i++) {
      try {
        tizen.tvinputdevice.unregisterKey(keys[i]);
      } catch (error) {
        console.log('failed to UNRegister ' + this.getKeys[i] + ': ' + error);
      }
    }
    /*
    // Kritische Tasten die BLOCKIERT werden müssen
    const BLOCKED_KEYS = [
        10252,  // Home/Smart Hub - KRITISCH!
        10232,  // Ambient Mode - IHR HAUPTPROBLEM!
        10009,  // Back/Return
        10182,  // Exit
        10072,  // Source
        10135,  // Menu/Tools
        10253,  // Settings/Voice
        10077,  // Apps
        427,    // Channel Up
        428,    // Channel Down
        10074,  // Netflix
        10256,  // Prime Video
        10257,  // Disney+
        10259,  // Gaming Hub
    ];

    // Event Handler
    document.addEventListener('keydown', function(event) {
        const keyCode = event.keyCode || event.which;

        if (BLOCKED_KEYS.includes(keyCode)) {
            console.log('🚫 Blockiere Taste:', keyCode);
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            return false;
        }
    }, true); // true = capture phase!
    */
  }
  static unregisterKeys() {
    for (let i = 0; i < this.getKeys.length; i++) {
      try {
        tizen.tvinputdevice.unregisterKey(this.getKeys[i]);
      } catch (error) {
        console.log('failed to register ' + this.getKeys[i] + ': ' + error);
      }
    }
  }


static setPowerStateListener() {
  console.log('SET POWER STATE LISTENER');
  try {
    if (window.b2bapis) {
      const onChange = (context) => {
        const state = context.data;
        console.log('::===> POWER_STATE (b2bapis)', state);
        if (state === 'Normal') {
          StorageHandler.save(STORE_KEY.POWER_STATE, STORE_VALUE.POWER_ON);
        } else if (state === 'Standby') {
          // FIX: POWER_OFF speichern, sonst wacht TV sofort wieder auf
          StorageHandler.save(STORE_KEY.POWER_STATE, STORE_VALUE.POWER_OFF);
        }
      };
      Device.apis.b2bpower.setPowerStateChangeListener(onChange);
      // Initialen Zustand synchronisieren
      const currentPowerState = Device.apis.b2bpower.getPowerState();
      console.log('::===> INITIAL POWER_STATE sync (b2bapis):', currentPowerState);
      StorageHandler.save(
        STORE_KEY.POWER_STATE,
        currentPowerState === 'Normal' ? STORE_VALUE.POWER_ON : STORE_VALUE.POWER_OFF
      );

    } else if (window.webapis) {
      // webapis.systemcontrol.setPowerStateChangeListener nicht auf allen Firmwares verfügbar
      // → PowerStateWrapper nutzt visibilitychange + Tizen app-Lifecycle (zuverlässiger)
      if (!this.powerWrapper) {
        this.powerWrapper = new PowerStateWrapper({
          onResume: () => {
            console.log('::===> POWER_STATE onResume → ON');
            StorageHandler.save(STORE_KEY.POWER_STATE, STORE_VALUE.POWER_ON);
          },
          onVisible: () => {
            console.log('::===> POWER_STATE onVisible → ON');
            StorageHandler.save(STORE_KEY.POWER_STATE, STORE_VALUE.POWER_ON);
          },
        });
        this.powerWrapper.init();
      }
      // Initialen Zustand synchronisieren
      const currentPowerState = window.webapis.remotepower.getPowerState();
      console.log('::===> INITIAL POWER_STATE sync:', currentPowerState);
      StorageHandler.save(
        STORE_KEY.POWER_STATE,
        currentPowerState === 'NORMAL' ? STORE_VALUE.POWER_ON : STORE_VALUE.POWER_OFF
      );
    }
  } catch (error) {
    console.log('[ERROR]: setPowerStateListener!', error);
  }
}

static unsetPowerStateListener() {
  console.log('UNSET POWER STATE LISTENER');
  try {
    if (window.b2bapis) {
      Device.apis.b2bpower.unsetPowerStateChangeListener();
    } else if (window.webapis) {
      if (this.powerWrapper) {
        this.powerWrapper.destroy();
        this.powerWrapper = null;
      }
    }
  } catch (error) {
    console.log('[ERROR]: ON UNSET POWER STATE CHANGE LISTENER', error);
  }
}

  /*
  static setPowerStateListener() {
    console.log("============================================== SET POWER STATE LISTENER");

    if (this.powerWrapper) return;

    this.powerWrapper = new PowerStateWrapper({
      onResume() {
        console.log("::===> POWER_STATE RESUME (POWER ON)");
        StorageHandler.save(
          STORE_KEY.POWER_STATE,
          STORE_VALUE.POWER_ON
        );
      },

      onVisible() {
        console.log("::===> POWER_STATE VISIBLE");
        StorageHandler.save(
          STORE_KEY.POWER_STATE,
          STORE_VALUE.POWER_ON
        );
      },

      onSuspend() {
        console.log("::===> POWER_STATE SUSPEND");
      },

      onHidden() {
        console.log("::===> POWER_STATE HIDDEN");
      },
    });

    this.powerWrapper.init();
  }

  static unsetPowerStateListener() {
    console.log("============================================== UNSET POWER STATE LISTENER");

    if (!this.powerWrapper) return;

    this.powerWrapper.destroy();
    this.powerWrapper = null;
  }
*/

}



// WEBPACK FOOTER //
// ./src/mixins/keyHandler/Tizen.js